import { difference, flattenDeep } from "lodash";

import { EquipmentClass } from "./EquipmentClass";
import { EquipmentClassFunctions } from "./EquipmentClassFunctions";
import { EquipmentFunctionalityTypeFunctions } from "./EquipmentFunctionalityTypeFunctions";
import type { IDirectConnection } from "./IDirectConnection";
import type { IEquipmentFunctionalityType } from "./IEquipmentFunctionalityType";
import type { IEquipmentType } from "./IEquipmentType";
import type { IEquipmentTypeSlim } from "./IEquipmentTypeSlim";

export class EquipmentTypeFunctions {
    public static enhanceEquipmentType<T extends IEquipmentTypeSlim>(et: T): T {
        if (et === undefined || et === null) {
            return et;
        }

        et.className = et.class as any as keyof typeof EquipmentClass;
        et.class = EquipmentClass[et.className];
        et.icon = EquipmentClassFunctions.EquipmentClassIcon(et.class);

        const manufacturer = et.manufacturer ? et.manufacturer.name : "";
        const version = et.version || "";

        et.displayName = `${manufacturer} ${et.model} ${version}`;

        const equipmentType = et as IEquipmentTypeSlim as IEquipmentType;

        if (equipmentType.functionalityTypes !== undefined) {
            equipmentType.functionalityTypes = equipmentType.functionalityTypes.map((ft) =>
                EquipmentFunctionalityTypeFunctions.enhanceFunctionalityTypeSlim(ft),
            );
        }
        return et;
    }

    public static checkEquipmentTypeCompability(
        directConnections: IDirectConnection[],
        functionalityTypes: IEquipmentFunctionalityType[],
    ) {
        const typeNeedsToBeSupported = directConnections.map((dc) => dc.directConnectionType);

        const typesAvailable = flattenDeep(
            functionalityTypes.map((ft) => ft.availableChannels.map((ac) => ac.supportedDirectConnections)),
        );

        return difference(typeNeedsToBeSupported, typesAvailable as any).length === 0;
    }
}
